import { rem } from "polished";

import { ButtonColorTheme } from "./types";

// /!\ color palet is not complet enough at the time : we use custom color instead
// should be changed once color palet is reworked
export const buttonColors: ButtonColorTheme = {
  primary: {
    primary: {
      normal: { color: "#FFFFFF", backgroundColor: "#016fe5", outlineColor: "transparent" },
      hover: { backgroundColor: "#015dbf" },
      active: { backgroundColor: "#014da0" },
      focus: { outlineColor: "#b1cbf1" },
      disabled: { backgroundColor: "#89b1ee" },
    },
    secondary: {
      normal: { color: "#343a40", backgroundColor: "#343A4014", outlineColor: "transparent" },
      hover: { backgroundColor: "#343A4024" },
      active: { backgroundColor: "#343A4050" },
      focus: { outlineColor: "#343A4050" },
      disabled: { color: "#343a4050", outlineColor: "" },
    },
    tertiary: {
      normal: { color: "#343a40", backgroundColor: "transparent", outlineColor: "transparent" },
      hover: { backgroundColor: "#343A4024" },
      active: { backgroundColor: "#343A4050" },
      focus: { outlineColor: "#343A4050" },
      disabled: { color: "#343a4050", outlineColor: "" },
    },
  },
  red: {
    primary: {
      normal: { color: "#FFFFFF", backgroundColor: "#DE001B", outlineColor: "transparent" },
      hover: { backgroundColor: "#c40018" },
      active: { backgroundColor: "#a80014" },
      focus: { outlineColor: "#ec8a8d" },
      disabled: { backgroundColor: "#ec8a8d" },
    },
    secondary: {
      normal: { color: "#df001a", backgroundColor: "#F9E1E4", outlineColor: "transparent" },
      hover: { backgroundColor: "#f5d3d7" },
      active: { backgroundColor: "#f0c5ca" },
      focus: { outlineColor: "#ec8a8d" },
      disabled: { color: "#ec8a8d", backgroundColor: "#f6ebed" },
    },
    tertiary: {
      normal: { color: "#df001a", backgroundColor: "transparent", outlineColor: "transparent" },
      hover: { backgroundColor: "#f9e1e4" },
      active: { backgroundColor: "#f7e6e9" },
      focus: { outlineColor: "#ec8a8d" },
      disabled: { color: "#ec8a8d" },
    },
  },
};

const commonButtonSizes = {
  small: {
    gap: 2,
    fontSize: rem(12),
    lineHeight: rem(16),
    svg: { width: rem(14), height: rem(14), margin: 1 },
  },
  medium: {
    gap: 4,
    fontSize: rem(14),
    lineHeight: rem(20),
    svg: { width: rem(16), height: rem(16), margin: 1 },
  },
  large: {
    gap: 6,
    fontSize: rem(16),
    lineHeight: rem(24),
    svg: { width: rem(18), height: rem(18), margin: 1 },
  },
};

export const buttonSizes = {
  small: { ...commonButtonSizes.small, paddingBlock: 4, paddingInline: 8 },
  medium: { ...commonButtonSizes.medium, paddingBlock: 6, paddingInline: 12 },
  large: { ...commonButtonSizes.large, paddingBlock: 8, paddingInline: 16 },
};

export const iconButtonSizes = {
  small: { ...commonButtonSizes.small, padding: 4 },
  medium: { ...commonButtonSizes.medium, padding: 7 },
  large: { ...commonButtonSizes.large, padding: 10 },
};
